<template>
    <Modal v-model="show"
        title="客户经理项目人账号信息"
        :width="60">
        <Spin v-if="$globalSpin"
            size="large"
            fix></Spin>
        <Form ref="userForm"
            :model="userForm"
            :rules="ruleValidate"
            label-position="top"
            class="small-form">

            <Row :gutter="16">
                <Col span="6">
                <FormItem label="登录帐号"
                    prop="userName">
                    <Input v-model="userForm.userName" placeholder="请以P开头"
                        :readonly="formEditMode===FORM_EDIT_MODE_MODIFY"></Input>
                </FormItem>
                </Col>
                <Col span="6">
                <FormItem label="角色" prop="roleUuid">
                    <Select placeholder="请选择角色" v-model="userForm.roleUuid" filterable clearable>
						<Option v-for="(item,index) in roleIdList" :value="item.roleUuid" :key="item.roleUuid">{{ item.name }}</Option>
					</Select>
                </FormItem>
                </Col>
				<Col span="6">
				<FormItem label="姓名" prop="userPersonName">
                    <Input placeholder="请输入姓名" v-model="userForm.userPersonName"></Input>
				</FormItem>
				</Col>
                <Col span="6">
                <FormItem label="手机"
                    prop="userPhone">
                    <Input placeholder="请输入手机号" v-model="userForm.userPhone"></Input>
                </FormItem>
                </Col>
                
            </Row>
            <Row :gutter="16">
                <Col span="6">
                <FormItem label="状态">
                    <RadioGroup v-model="userForm.userStatus"
                        type="button">
                        <Radio v-for="item in approvalSource"
                            :key="item.val"
                            :label="item.val">{{ item.label }}
                        </Radio>
                    </RadioGroup>
                </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="部门" prop="department">
                        <Select
                            v-model="userForm.departmentUuid"
                            clearable
                            filterable
                        >
                            <Option
                                v-for="item in departmentList"
                                :key="item.departmentUuid"
                                :value="item.departmentUuid"
                                >{{ item.departmentName }}-{{ item.departmentContact }}</Option
                            >
                        </Select>
                    </FormItem>
                </Col>
                <Col v-if="formEditMode === FORM_EDIT_MODE_CREATE"
                    span="6">
                <FormItem label="密码">
                    <Input placeholder="请输入密码" v-model="password"
                        type="password"></Input>
                </FormItem>
                </Col>
                <Col v-if="formEditMode === FORM_EDIT_MODE_CREATE" span="6">
                <FormItem label="密码确认">
                    <Input placeholder="请输入密码确认" v-model="passwordConfirm"
                        type="password"></Input>
                </FormItem>
                </Col>
            </Row>
            
        </Form>
        <div slot="footer">
            <Button type="primary"
                @click="onSave">确认</Button>
            <Button type="error"
                @click="onCancel">取消</Button>
        </div>
    </Modal>
</template>

<script>
import { STATUS_ACTIVE, STATUS_INACTIVE, statusFormat } from '@/libs/baseModelFormat';
import { FORM_EDIT_MODE_CREATE, FORM_EDIT_MODE_MODIFY } from '@/view/mixins/form-edit-mode';

import { getRoleList, inspectorUserSave, getInspectorUserDetail, getUserPersonNameList } from '@/api/modules/account-management/inspector-user-management';

export default {
    name: 'ProjectUserEdit',
    props: {
        departmentList: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            show: false,
            accountUuid: '',
            FORM_EDIT_MODE_CREATE,
            FORM_EDIT_MODE_MODIFY,
            formEditMode: FORM_EDIT_MODE_CREATE,
            pageLoading: false,
            userForm: {
                userUuid: '',
                userName: '',
                userPersonName: '',
                userPhone: '',
                userType: 'P',
                roleUuid: '',
                departmentUuid: '',
                userStatus: STATUS_ACTIVE
            },
            ruleValidate: {
                userName: [
                    {
                        trigger: 'blur',
                        required: true,
                        validator: (rule, value, callback) => {
                            if (!value) {
                                callback(new Error('请输入登录账号'));
                            }
                            else if (value.length < 3 || value.length > 20) {
                                callback(new Error('账号长度在3-20个字符之间'));
                            }
                            else if (value.charAt(0) !== 'P') {
                                callback(new Error('账号开头必须为P'));
                            }
                            else {
                                callback();
                            }
                        }
                    }
                ],
                userPersonName: [
                    { required: true, message: '请输入姓名', trigger: 'blur' }
                ],
                userPhone: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号格式', trigger: 'blur' }
                ],
                roleUuid: [
                    { required: true, message: '请选择角色', trigger: 'change' }
                ]
            },
            password: '',
            passwordConfirm: '',
            approvalSource: [],
            roleIdList:[]
        };
    },
    mounted() {
        //this.init();
    },
    methods: {
        showModal(accountUuid) {
            if (!accountUuid) {
                this.accountUuid = '';
                this.formEditMode = FORM_EDIT_MODE_CREATE;
            }
            else {
                this.formEditMode = FORM_EDIT_MODE_MODIFY;
                this.accountUuid = accountUuid;
            }
            this.init();
            this.show = true;
        },
        init() {
            this.approvalSource = [
                { val: STATUS_ACTIVE, label: statusFormat(STATUS_ACTIVE) },
                { val: STATUS_INACTIVE, label: statusFormat(STATUS_INACTIVE) }
            ];
            this.initUserForm();

            getRoleList({ type: '客户经理项目人' }).then(res => {
                if (res.code === 0 && res.data.records) {
                    this.roleIdList = res.data.records;
                }
            });

            if (this.accountUuid) {
                this.formEditMode = FORM_EDIT_MODE_MODIFY;
                getInspectorUserDetail({ userUuid: this.accountUuid }).then(res => {
                    this.$hideGlobalSpin();
                    if (res.code === 0) {
                        const info = res.data.userModel;
                        this.userForm.userUuid = info.userUuid;
                        this.userForm.userName = info.userName;
                        this.userForm.userPersonName = info.userPersonName;
                        this.userForm.userPhone = info.userPhone;
                        this.userForm.userStatus = info.userStatus;
                        this.userForm.userType = info.userType;
                        this.userForm.roleUuid = info.roleUuid;
                        this.userForm.departmentUuid = info.departmentUuid;
                    }
                }).catch(() => {
                    this.$hideGlobalSpin();
                });
            }
            else {
                this.$refs.userForm.resetFields();
            }
        },
        initUserForm(){
            this.userForm.userUuid = '',
            this.userForm.userName = '';
            this.userForm.userPersonName = '';
            this.userForm.userPhone = '';
            this.userForm.userStatus = 1;
            this.userForm.userType = 'P';
            this.userForm.roleUuid = '';
            this.userForm.departmentUuid = '';
        },
        onSave() {
            this.$refs.userForm.validate(valid => {
                if (!valid) {
                    this.$Message.error('表单验证失败!');
                    return;
                }

                if (this.formEditMode === FORM_EDIT_MODE_CREATE) {
                    if (!this.password) {
                        this.$Message.error('请输入密码!');
                        return;
                    }
                    if (this.password !== this.passwordConfirm) {
                        this.$Message.error('两次输入的密码不一致!');
                        return;
                    }
                }

                const data = Object.assign({ formEditMode: this.formEditMode }, this.userForm);
                if (this.formEditMode === FORM_EDIT_MODE_CREATE) {
                    data.password = this.password;
                    data.passwordConfirm = this.passwordConfirm;
                }

                this.$showGlobalSpin();
                inspectorUserSave(data).then(res => {
                    this.$hideGlobalSpin();
                    if (res.code === 0) {
                        this.$Modal.success({
                            title: '保存成功',
                            onOk: () => {
                                this.show = false;
                                this.$refs.userForm.resetFields();
                                this.$parent.getProjectUserTableRecords();
                            }
                        });
                    }
                });
            });
        },
        onCancel() {
            this.show = false;
            this.$refs.userForm.resetFields();
        }
    }
};
</script>

<style scoped>
</style>
